import { z } from 'zod'
import { LoginUtil } from '@ca/common'

export const contactModalSchema = z
  .object({
    mobile: z.string().optional(),
    email: z.string().optional(),
    phone: z.string().optional(),
  })
  .superRefine((val, ctx) => {
    if (!val.mobile && !val.email && !val.phone) {
      ctx.addIssue({
        path: ['email'],
        code: 'custom',
        message: 'required',
      })
      ctx.addIssue({
        path: ['mobile'],
        code: 'custom',
        message: 'required',
      })
      return
    }
    if (val.mobile && !LoginUtil.isPhone(val.mobile)) {
      ctx.addIssue({
        path: ['mobile'],
        code: 'custom',
        message: 'mobile.invalid',
      })
    }
    if (val.email && !LoginUtil.isEmail(val.email)) {
      ctx.addIssue({
        path: ['email'],
        code: 'custom',
        message: 'email.invalid',
      })
    }
  })
